import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';
import { getFormattedPrice } from 'webapp/utils/number';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import SubmitButtonComponent from 'webapp/components/submit-button';

type Args = Record<string, never>;

export default class BillingAiCreditsInfoComponent extends Component<Args> {
	@service('billing') declare billingService: Service.Billing;

	get quantity(): number {
		return this.billingService.aiCreditPackItem?.quantity || 0;
	}

	get creditsPerMonthFormatted(): string {
		const totalCredits = this.quantity * this.billingService.aiCreditsInOnePack;
		return totalCredits.toLocaleString('en-US');
	}

	// always billed monthly
	get priceFormatted(): string {
		return getFormattedPrice(this.billingService.extraAiCreditsMonthlyPriceCents, 2);
	}

	@action
	manage(): void {
		// this panel only renders on the billing overview page
		this.billingService.openAiCreditsPurchasePopup('billing_page');
	}

	<template>
		<div class="ai-credits-info">
			<div class="ai-credits-info__main">
				<CommonUiIconComponent @name="Ai" @size="md" @class="ai-credits-info__icon" />
				<div class="ai-credits-info__text">
					<strong>Extra AI credits</strong>
					<span>{{this.creditsPerMonthFormatted}} credits/mo</span>
				</div>
			</div>
			<div class="ai-credits-info__aside">
				<div class="ai-credits-info__price">
					<strong>{{this.priceFormatted}}</strong>/mo
				</div>
				<SubmitButtonComponent
					@text="Manage"
					@theme="grey-outlined"
					@noDelay={{true}}
					@onTrigger={{this.manage}}
				/>
			</div>
		</div>
	</template>
}
